export class OpcoesGestorPaginado {
    constructor(
        public offset: number,
        public pageSize: number,
        public cpf: string,
        public name: string,
        public status: string,
        public search: string,
        public permitirBuscarNome: boolean,
        public permitirBuscarNomeLike: boolean,
        public permitirBuscarCpf: boolean,
        public permitirBuscarCpfLike: boolean,
        public permitirBuscarStatus: boolean,
    ) {

    }
}
